/**
 * Feature flag for the "Use the Cuddles default instead" escape link shown
 * under the sender email in the Verified / Pending / Failed states.
 *
 * Hidden while the mandatory-sender rule is in effect — sends without a
 * verified custom sender are blocked upstream (see `isSenderReadyForSend`),
 * so offering the escape here would let users opt back into a Cuddles-
 * default flow that no longer works end-to-end.
 *
 * The escape flow itself — the confirm modal (`UseCuddlesDefaultConfirmModal`),
 * the handler on the parent component, the shared SCSS — is intentionally
 * left in place. Flipping this flag back to `true` re-enables the link
 * without any other change.
 */
export const SHOW_CUDDLES_DEFAULT_ESCAPE = false;
